module.exports = __webpack_public_path__ + "static/media/gustavo_silvamaral.349f53cd.webp";